interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function MenuCloseIcon(props: Props) {
  const { size = 32, className } = props;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 23.8492L23.8492 9M9 9L23.8492 23.8492"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
}
